export const NO_CATEGORY_KEY = 'undefined';

export const EMPTY_CATEGORY_KEYS: ReadonlySet<string> = new Set();

type CategorizedOption = {
  category?: string;
  categoryOrder?: number;
};

export type CategoryToDisplay = {
  category: string;
  index: number;
};

export const getCategoryKey = (option: CategorizedOption): string => option.category ?? NO_CATEGORY_KEY;

export function sortOptionsByCategory<TOption extends CategorizedOption>(
  options: TOption[],
  noCategoryLabel: string,
): TOption[] {
  const lowerCaseNoCategoryLabel = noCategoryLabel.toLowerCase();

  return [...options].sort((optionA, optionB) => {
    const orderDiff = (optionA.categoryOrder ?? 0) - (optionB.categoryOrder ?? 0);
    if (orderDiff !== 0) return orderDiff;
    const categoryA = optionA.category?.toLowerCase() ?? lowerCaseNoCategoryLabel;
    const categoryB = optionB.category?.toLowerCase() ?? lowerCaseNoCategoryLabel;
    return categoryA.localeCompare(categoryB);
  });
}

export function getCategoriesToDisplay(options: CategorizedOption[]): CategoryToDisplay[] {
  const seenCategories = new Set<string>();

  return options.reduce<CategoryToDisplay[]>((accumulator, optionItem, optionIndex) => {
    const categoryName = optionItem.category || NO_CATEGORY_KEY;
    if (!seenCategories.has(categoryName)) {
      seenCategories.add(categoryName);
      accumulator.push({ category: categoryName, index: optionIndex });
    }
    return accumulator;
  }, []);
}
